const initState = {
  dimensionsError: null,
  dimensions: {
    width: {},
    doors: {},
    height: [],
    depth: {},
    types: [],
  },
};

const dimensionsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_DIMENSIONS_ERROR':
      return {
        ...state,
        dimensionsError: action.data,
      };
    case 'GET_DIMENSIONS_SUCCESS':
      return {
        ...state,
        dimensions: action.data,
        dimensionsError: null,
      };
    default:
      return state;
  }
};

export default dimensionsReducer;
